import {AUTH_EMAIL, AUTH_PASSWORD, BANK_BRANCH_GUID, COMPANY_ID, ENV, ENV_TYPE, IVERY_BASEURL, LITE_MERCHANT_APP_ID, MIDDLEWARE_URL, SITE_URL, NETWORK_ID, OCP_APIM_SUBSCRIPTION_KEY, PAYMENT_CONFIGURATION_KEY, PRODUCT_INSTANCE_ID, RECAPTCHA_SITE_KEY} from './api-constants';

// <-------- Constants ------->

// Define the ENV TYPE in ENV_VAR
const ENV_VAR = ENV_TYPE[process.env.REACT_APP_ENV_TYPE];


const CONSTANTS = {
  BASEURL: ENV[ENV_VAR],
  ENV: ENV_VAR,
  OCP_APIM_SUBSCRIPTION_KEY: OCP_APIM_SUBSCRIPTION_KEY[ENV_VAR],
  PRODUCT_INSTANCE_ID: PRODUCT_INSTANCE_ID[ENV_VAR],
  AUTH_EMAIL: AUTH_EMAIL[ENV_VAR],
  AUTH_PASSWORD: AUTH_PASSWORD[ENV_VAR],
  IVERY_BASEURL: IVERY_BASEURL[ENV_VAR],
  LITE_MERCHANT_APP_ID: LITE_MERCHANT_APP_ID[ENV_VAR],
  BANK_BRANCH_GUID: BANK_BRANCH_GUID[ENV_VAR],
  NETWORK_ID: NETWORK_ID[ENV_VAR],
  COMPANY_ID: COMPANY_ID[ENV_VAR],
  REDIRECTION_SUCCESS_URL: `${MIDDLEWARE_URL[ENV_VAR]}/surething/payment-success`,
  REDIRECTION_ERROR_URL: `${MIDDLEWARE_URL[ENV_VAR]}/surething/payment-error`,
  MIDDLEWARE_URL: MIDDLEWARE_URL[ENV_VAR],
  SITE_URL: SITE_URL[ENV_VAR],
  EXTERNAL_PAYMENT_CONFIGURATION_KEY: PAYMENT_CONFIGURATION_KEY[ENV_VAR],
  RECAPTCHA_KEY: RECAPTCHA_SITE_KEY[ENV_VAR],
};
export default CONSTANTS;

export const PRODUCTION_CONSTANTS = {
  REFERER_BASE_URL_PROD: 'https://policy-cache-itp2-prod-za.azurewebsites.net',
  COMPANY_DETAILS: 'https://organisation-itp2-prod-za.azurewebsites.net',
  PRODUCT_RISKS: 'https://product-itp2-prod-za.azurewebsites.net',
  BANK_LOOKUPS: 'https://maintaindata-itp2-prod-za.azurewebsites.net',
  POLICY: 'https://policy-itp2-prod-za.azurewebsites.net'
}

// <-------- Common Messages ------->
export const COMMONMESSAGES = {};

export const RESTRICTED_QUESTIONS = {
  TYPE_LIST_8: [
    // DEV INSTANCE ID
    'eca66467-c8ea-132f-e8cb-4a862aa7c726',
    '49c6d4c0-ba1e-24ab-cdc8-d9a5dda748c7',
    
    // LATEST DEV INSTANCE ID
    'c6fac081-1f35-43e6-a483-56214f052263',
    '37e7cd43-2fda-45be-8179-657162c08d17',

    // UAT INSTANCE ID
    '36f66c7f-211c-4143-a645-986ad2dcf880',
    '589e41e9-645a-4560-91c2-7edbac073541',

    'e026e0d7-e11f-40f2-8018-fcabe005d677',
    '07c74cee-68e2-494f-8ad7-981bfad68845'
  ],
  INDUSTRY_QUESTION: [
    // DEV INSTANCE ID
    '49c6d4c0-ba1e-24ab-cdc8-d9a5dda748c7',

    // LATEST DEV INSTANCE ID
    '37e7cd43-2fda-45be-8179-657162c08d17',

    // UAT INSTANCE ID
    '36f66c7f-211c-4143-a645-986ad2dcf880',

    'e026e0d7-e11f-40f2-8018-fcabe005d677'
  ],
  ANNUAL_TURNOVER: [
    '589e41e9-645a-4560-91c2-7edbac073541',
    'c6fac081-1f35-43e6-a483-56214f052263',

    // LATEST DEV INSTANCE ID
    'c6fac081-1f35-43e6-a483-56214f052263',

    '07c74cee-68e2-494f-8ad7-981bfad68845'
    
  ],
  HIDDEN_QUESTIONS: [
    // DEV INSTANCE ID
    '4182ef52-0e6c-c9ce-a62e-5dfd37bf4341',

    // LATEST DEV INSTANCE ID
    '35a970c4-f27c-4be6-bdcf-1dd5cdc8f4bc',

    // UAT INSTANCE ID
    '64a60644-7b8e-47bb-8786-76e078a7be61',

    '930a0911-20a0-4ef1-9dbf-1c3f851419a0'
  ],
  HIDE_QUESTIONS: [
    // DEV INstance
    '25f4ba02-bda4-6edc-e43a-d0734ceb5229',
    // UAT Instance
    '799ab412-4480-fc54-b22f-563561ea455a',

    'ea675d32-5d4f-3b7e-d29e-fb53ddbb2d84'
  ]
}
